<template>
  <div class="bg-gray">
    <navigation-bar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
          <div class="row">
            <div class="col-xs-12 col-sm-12 text-left">
              <div class="row">
                <div class="col-sm-6">
                  <h1 style="float:left;">Create a Listing</h1>
                </div>
              </div>
              <div class="row" style="padding-left:15px;margin-bottom:20px;">
                <small>Need help? Watch <a href="https://www.facebook.com/101558791557537/videos/599133124063083" target="_blank"> this short video</a></small>
              </div>
              <hr>
              <div class="row">
                <div class="col-sm-12" v-if="store.state.screen == 'Service'">
                  <div class="form-group">
                    <label>Select a Category</label>
                    <br />
                    <small>Select the category your listing will be posted in</small>

                    <div class="row">
                      <div
                        class="col-sm-3"
                        v-for="service in store.state.services"
                        :key="service.id"
                      >
                        <button
                          class="btn btn-default"
                          style="width:100%;background:white;margin:10px;"
                          @click="serviceClicked(service)"
                        >
                          <div>
                            <img
                              :class="{'blue-overlay':service.icon != 'yoga-mat.png'}"
                              v-if="service.icon"
                              style="margin-right:10px"
                              :src="getImgUrl(service.icon)"
                              width="30px"
                              height="30px"
                            />
                            <span>{{service.name}}</span>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div style="margin-left:10px;margin-bottom:10px;">
                    <small
                      v-if="store.state.selectedService"
                    >{{store.state.selectedService.description}}</small>
                  </div>
                </div>
                <div class="col-6 col-sm-2" v-if="store.state.selectedService">
                  <h4>Selected Service</h4>
                  <div class="row">
                    <div class="col-12 col-sm-10">
                      <button
                        class="btn btn-default"
                        style="width:100%;background:white;margin:10px;"
                      >
                        <div v-if="store.state.selectedService">
                          <img
                            :class="{'blue-overlay':store.state.selectedService.icon != 'yoga-mat.png'}"
                            v-if="store.state.selectedService.icon"
                            style="margin-right:10px"
                            :src="getImgUrl(store.state.selectedService.icon)"
                            width="30px"
                            height="30px"
                          />
                          <span>{{store.state.selectedService.name}}</span>
                        </div>
                      </button>
                    </div>

                    <div class="col-12 col-sm-2" v-if="store.state.selectedService">
                      <button
                        class="btn btn-primary btn-blue"
                        style="margin:10px;"
                        @click="store.state.screen = 'Service'"
                      >
                        <div v-if="store.state.selectedService">
                          <span>Change</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12" v-if="store.state.price">
                  <h4>Selected Price</h4>
                  <span v-if="store.state.price == 'free'">{{store.state.price}}</span>
                  <span v-else-if="store.state.price != ''">${{store.state.price}}/Month</span>
                  <br />
                  <button
                    v-if="store.state.price !='free' && store.state.price != ''"
                    class="btn btn-primary btn-blue"
                    style="margin:10px;"
                    @click="store.state.screen = 'Price'"
                  >
                    <div v-if="store.state.selectedService">
                      <span>Change</span>
                    </div>
                  </button>
                </div>
                <hr />
              </div>
              <hr />
              <div class="row" style="margin-top:20px;" v-if="store.state.screen == 'Price'">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>
                      <strong>Listing Font Size/Price</strong>
                    </label>
                    <br />
                    <small>
                      Select the price
                      <span v-if="store.state.selectedService.id > 1">and font size</span> of your listing
                    </small>

                    <div class="row">
                      <div class="col-sm-4" v-for="price in store.state.prices" :key="price.id">
                        <button
                          class="btn btn-default"
                          style="width:100%;background:white;margin:10px;"
                          @click="priceClicked(price)"
                        >
                          <div>
                            <span v-if="price.price == 'free'">{{price.name}} ({{price.price}})</span>
                            <span v-else>{{price.name}} (${{price.price}}/Month)</span>
                          </div>
                        </button>
                        <br />

                        <span v-if="price.name == 'Small'">
                          <p style="padding-left:10px">
                            Example:
                            <span class="small">{{getNameField()}}</span>
                          </p>
                        </span>
                        <span v-else-if="price.name == 'Medium'">
                          <p style="padding-left:10px">
                            Example:
                            <span class="medium">{{getNameField()}}</span>
                          </p>
                        </span>
                        <span v-else-if="price.name == 'Large'">
                          <p style="padding-left:10px;font-size:small;">Includes the option to add a photo/logo and customize the colors</p>
                          <p style="padding-left:10px">
                            Example:
                            <span class="large">{{getNameField()}}</span>
                          </p>
                        </span>
                      </div>
                    </div>

                    <p
                      v-if="store.state.threeMonthTrial == 'Y' && store.state.price != 'free'"
                    >Includes free 3 month trial!</p>
                  </div>
                </div>
              </div>



              <div
                class="row"
                v-if="(store.state.screen == 'Info' || store.state.screen == 'Done') && (store.state.size == 'Large' || store.state.selectedService.id == 1)"
              >
                  <div class="col-sm-12">
                  <p>
                    <strong>Upload a Photo</strong>
                  </p>
                  <small>You can upload a photo or logo to appear next to your listing. <br>We recommend uploading a square image to avoid cropping/cutting off your image.</small>
                  <br>
                  <div class="row">
                    <div class="col-sm-12" style="text-align:center;margin-top:20px;">
                      <img v-if="store.state.photo" width="100px" height="100px" style="object-fit:cover;" :src="fileUrl(store.state.photo)"/>
                      <br><br>

                      <file-selector  
                        accept-extensions=".jpg,.png,.jpeg"
                        :multiple="false"
                        :max-file-size="10 * 1024 * 1024"
                        @validated="handleFilesValidated"
                        @changed="handleFilesChanged"
                        ><button class="btn btn-blue">Select a Logo/Image</button>
                        </file-selector
                      >
                      <button style="margin-top:20px;" @click="removePhoto" v-if="store.state.photo" class="btn btn-primary btn-orange">Remove Photo</button>
                      
                    </div>
                  </div>
                    </div>

                    <div class="col-sm-12">
                      <p>
                        <strong>Customize Colors</strong>
                      </p>
                      <div class="row">
                        <div class="col-12 col-sm-6">
                          <label>Background Color</label>
                          <chrome v-model="store.state.background" />
                        </div>
                        <div  class="col-12 col-sm-6">
                          <label>Text Color</label>
                          <chrome v-model="store.state.textColor" />
                        </div>
                      </div>
                      

                  </div>
              </div>


              <div class="row" v-if="store.state.screen == 'Info' || store.state.screen == 'Done'">
                <div class="col-sm-12">
                  <br />
                  <p>
                    <strong>Your Info</strong>
                  </p>
                </div>
                <div class="col-sm-6" v-for="field in store.state.fields" :key="field.id">
                  <div class="form-group">
                    <label>
                      {{field.name}}
                      <span v-if="field.required" style="color:red">*</span>
                    </label>
                    <div
                      v-if="field.type == 'Text' || field.type == 'Email' || field.type == 'Website' || field.type == 'Number'"
                    >
                      <input
                        v-on:keyup="$forceUpdate()"
                        class="form-control"
                        v-model="store.state.form[field.id]"
                        type="text"
                        :placeholder="field.name"
                      />
                      <span
                        v-if="field.characterLimit > 0"
                      >{{store.state.form[field.id].length}}/{{field.characterLimit}}</span>
                    </div>
                    <div v-if="field.type == 'Text Area'">
                      <textarea
                        v-on:keyup="$forceUpdate()"
                        class="form-control"
                        v-model="store.state.form[field.id]"
                        type="text"
                        :placeholder="field.name"
                      />
                      <span
                        v-if="field.characterLimit > 0"
                      >{{store.state.form[field.id].length}}/{{field.characterLimit}}</span>
                    </div>
                    <div v-if="field.type == 'Date'">
                      <input
                        class="form-control"
                        v-model="store.state.form[field.id]"
                        type="date"
                        :placeholder="field.name"
                      />
                    </div>
                    <div v-if="field.type == 'Y/N'">
                      <select class="form-control" v-model="store.state.form[field.id]">
                        <option value>---Select One---</option>
                        <option value="Y">Yes</option>
                        <option value="N">No</option>
                      </select>
                    </div>
                    <div v-if="field.type == 'Select Dropdown'">
                      <select class="form-control" v-model="store.state.form[field.id]">
                        <option value>--Select One---</option>
                        <option
                          v-for="option in selectOptions(field)"
                          :key="option"
                          :value="option"
                        >{{option}}</option>
                      </select>
                    </div>
                    <div v-if="field.type == 'Multi Select Dropdown'">
                      <div class="row">
                        <div class="col-sm-6" v-for="option in selectOptions(field)" :key="option">
                          <div class="form-check">
                            <label
                              style="width:200px;background:white;"
                              :for="'default-' + option"
                              class="btn btn-default btn-blue"
                            >
                              <span style="float:left;">{{option}}</span>
                              <input
                                @click="multiSelectClick($event,field,option)"
                                style="float:right;"
                                type="checkbox"
                                :id="'default-' + option"
                                class="badgebox"
                              />
                              <span class="badge">&check;</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>City</label>
                    <span style="color:red">*</span>
                    <input
                      v-on:keyup="$forceUpdate()"
                      class="form-control"
                      v-model="store.state.hometownCity"
                      type="text"
                      placeholder="City"
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>State</label>
                    <span style="color:red">*</span>
                    <select
                      @change="stateChanged()"
                      class="form-control"
                      v-model="store.state.hometownState"
                    >
                      <option value></option>
                      <option v-for="state in utils.states()" :key="state">{{state}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-12" style="text-align:center;margin-bottom:20px;" v-if="store.state.price != 'free'">
                  <button class="btn btn-primary btn-blue" @click="store.state.screen = 'Done'">Next</button>
                </div>
              </div>
              <div
                class="row"
                style="background-color:lightgray;"
                v-if="store.state.price != 'free' && store.state.screen == 'Done'"
              >
                <div class="col-sm-12 text-center" style="margin-top:50px;">
                  <h3
                    v-if="store.state.calculatedPrice != '' && store.state.price != 'free'"
                  >${{store.state.calculatedPrice}}/Month</h3>
                  <p
                    v-if="store.state.threeMonthTrial == 'Y' && store.state.price != 'free'"
                  >Your listing will be free for the first 3 months!</p>
                  <div
                    class="form-group"
                    style="width:300px;margin:auto"
                    v-if="store.state.calculatedPrice != ''"
                  >
                    <p>Have a coupon?</p>
                    <input
                      class="form-control"
                      v-model="store.state.couponName"
                      placeholder="Coupon"
                    />
                    <button
                      @click="applyCoupon"
                      style="width:100%;margin-top:20px;margin-bottom:40px"
                      class="btn btn-primary btn-orange"
                    >Apply Coupon</button>
                  </div>
                </div>
              </div>

              <div class="row" v-if="store.state.screen == 'Done' || store.state.price == 'free'">
                <div class="col-sm-12 text-center" style="margin-top:50px;">
                  <div class="form-group">
                    <button
                      @click="saveListing"
                      style="width:250px;height:50px;font-size:x-large;"
                      class="btn btn-primary btn-blue"
                      :disabled="store.state.loading"
                    >Create Listing <span v-if="store.state.calculatedPrice != 'free' && store.state.calculatedPrice != '0.00' && store.state.calculatedPrice != ''">& Pay</span></button>
                  </div>
                  <p
                    v-if="store.state.price != 'free'"
                  >Payment will be processed securely through PayPal</p>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from "../nav/NavigationBar";
import DashboardFooter from "../nav/Footer";
import Utils from "@/Utils/Utils";
import Navigator from "@/router/navigator";
import CreateListingStore from "./CreateListingStore";
import AccountSessionUtils from "./AccountSessionUtils";
import moment from "moment";
import { Chrome } from 'vue-color'

export default {
  name: "CreateListing",
  components: {
    NavigationBar,
    DashboardFooter,
    Chrome
  },
  data() {
    return {
      nav: Navigator,
      store: CreateListingStore,
      accountUtils: AccountSessionUtils,
      utils: Utils
    };
  },
  mounted() {
    this.store.reset();
    this.accountUtils.authorize(
      userId => {
        this.store.state.currentUserId = userId;
        if (userId == "0") {
          this.nav.goRegister(this, "CreateListing");
          return;
        }
        this.getServices();
        this.getPrices();
      },
      err => {
        this.$toasted.show(err, { type: "error", duration: 2500 });
      },
      () => {
        this.nav.goMaintenance(this);
      }
    );

    this.store.getThreeMonthTrial();
    this.store.getUser()
  },
  computed: {
    selectedService() {
      return (
        this.store.state.services.find(service => {
          return service.id == this.store.state.selectedService.id;
        }) || {}
      );
    },
    price() {
      if (!this.store.state.price) {
        return "";
      }
      var str = "Price: ";
      let priceName = this.store.state.price;
      let service = this.selectedService;

      return (str += "$" + this.store.state.price);
    }
  },
  methods: {
    getServices: function() {
      let self = this;
      this.store.getServices(
        data => {},
        err => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        },
        () => {
          this.nav.goMaintenance(this);
        }
      );
    },
    getPrices: function() {
      let self = this;
      this.store.getPrices(
        data => {
          this.$forceUpdate();
        },
        err => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        },
        () => {
          this.nav.goMaintenance(this);
        }
      );
    },
    selectOptions: function(field) {
      return field.selectOptions.split(",");
    },
    multiSelectClick: function($event, field, option) {
      if ($event.target.checked) {
        if (!this.store.state.form[field.id].includes(option)) {
          this.store.state.form[field.id].push(option);
        }
      } else {
        this.store.state.form[field.id] = this.store.state.form[
          field.id
        ].filter(it => {
          return it != option;
        });
      }
    },
    saveListing: function() {
      let self = this;
      if (
        this.store.state.cityStates.length == 0 &&
        this.store.state.selectedService.noStates == 0
      ) {
        this.addCityState();
      }
      this.store.saveListing(
        data => {
          if (
            this.store.state.calculatedPrice == "Free" ||
            this.store.state.calculatedPrice == "free" ||
            this.store.state.calculatedPrice == "0.00"
          ) {
            this.$toasted.show("Listing Created!", {
              type: "success",
              duration: 2500
            });
            this.store.reset();
            this.getServices();
            this.getPrices();
            self.nav.listingSuccess(self);
          } else {
            self.nav.goPay(self, data.listingId);
          }
        },
        err => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        },
        () => {
          this.nav.goMaintenance(this);
        }
      );
    },
    addCityState: function() {
      if (this.store.state.state == "") {
        return;
      }
      this.store.state.cityStates.push({
        state: this.store.state.state
      });

      this.store.state.state = "";
      this.store.calculatePrice();
    },
    allStates: function() {
      this.utils.states().forEach(state => {
        this.store.state.cityStates.push({
          city: "",
          state: state
        });
      });

      this.store.state.state = "";
      this.store.calculatePrice();
    },
    removeCityState: function(cityState) {
      this.store.state.cityStates = this.store.state.cityStates.filter(it => {
        return it !== cityState;
      });
    },
    getAdditionalPrice: function() {
      if (this.store.state.price == "free") {
        return "0";
      }
      let priceObj = this.store.state.prices.find(it => {
        return it.price == this.store.state.price;
      });

      if (!priceObj) {
        return "";
      }

      let name = priceObj.name;
      let additionalStatePriceObj = this.store.state.additionalStatePrices.find(
        it => {
          return it.name == name;
        }
      );

      if (!additionalStatePriceObj) {
        return "";
      }

      return additionalStatePriceObj.price;
    },
    applyCoupon: function() {
      this.store.validateCoupon(
        data => {
          this.store.calculatePrice();
        },
        err => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        },
        () => {
          this.nav.goMaintenance(this);
        }
      );
    },
    getNameField() {
      let nameField = this.store.state.fields.find(it => {
        return it.name == "Name";
      });

      if (!nameField) {
        return "John Doe";
      }

      let id = nameField.id;

      let value = this.store.state.form[id];
      if (!value || value.length == 0) {
        return "John Doe";
      }

      return value;
    },
    stateChanged() {
      this.store.state.state = this.store.state.hometownState;
    },
    getImgUrl(pic) {
      return require("@/assets/" + pic);
    },
    serviceClicked(service) {
      if (service.free == 1) {
        this.store.state.price = "free";
      } else {
        this.store.state.price = "";
      }
      this.store.state.selectedService = service;

      this.store.getFields(
        data => {
          this.$forceUpdate();
        },
        err => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        }
      );
      if (this.store.state.price != "free") {
        this.store.state.screen = "Price";
      } else {
        this.store.state.screen = "Info";
      }
      this.$forceUpdate();
    },
    priceClicked(price) {
      this.store.state.price = price.price;
      this.store.state.size = price.name;
      this.store.calculatePrice();
      this.store.state.screen = "Info";
    },
    handleFilesValidated(result, files) {
      console.log("Validation result: " + result);
    },

    handleFilesChanged(files) {
      if(files.length == 1) {
        this.store.state.photo = files[0]
        this.$forceUpdate()
      }
    },
    fileUrl(file) {
      return URL.createObjectURL(file);
    },
    removePhoto() {
      this.store.state.photo = null
      this.$forceUpdate()
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Hiding the checkbox, but allowing it to be focused */
.badgebox {
  opacity: 0;
}

.badgebox + .badge {
  /* Move the check mark away when unchecked */
  display: none;
  /* Makes the badge's width stay the same checked and unchecked */
  width: 27px;
}

.badgebox:checked + .badge {
  /* Move the check mark back when checked */
  display: block;
}

.badge {
  float: right;
  margin-top: 3px;
  padding-right: 0px;
  text-align: right;
}

.btn-blue {
  color: white;
}

.small {
  font-size: 90%;
}

.medium {
  font-size: 130%;
}

.large {
  font-size: 170%;
}

.blue-overlay {
  filter: invert(16%) sepia(14%) saturate(6187%) hue-rotate(205deg)
    brightness(92%) contrast(100%);
}
</style>



// WEBPACK FOOTER //
// src/components/account/CreateListing.vue